module.exports = __webpack_public_path__ + "Flag-854.825a7c1270ab47af81b88277f87fe5fd.svg";